import BaseService from './BaseService';

export interface OrderProps {
  id: number;
  payment_method: any;
  status: number;
  order?: any;
  cart?:any;
  type?: number;
}

export interface CreateProps {
  anti_fraud_session_id: string;
  payment_method_id: number;
  payment_method: any;
  store_id: number;
  order_type: number;
  cashier_id: number;
  store_cashiers?: any;
  status?: number;
  order?: any;
}

export interface DetailProps {
  order_id: number;
  cart?: any;
  status?: number;
  order?: any;
  payment_method?: any;
}

export interface CancelPaymentProps {
  cart_id: number;
}

export default class OrderService {
  baseService: BaseService;
  ApiBaseService: BaseService;
  constructor(orderType: string) {
    this.baseService = new BaseService(orderType);
    this.ApiBaseService = new BaseService('');
  }

  async create (payload: CreateProps): Promise<OrderProps> {
    try {
      const response = await this.baseService.http.post<OrderProps>('orders/create', payload);
      return response.data;
    } catch (error) {
      console.error('Erro create:', error);
      throw error;
    }
  }
  
  async checkOrdersOpen (): Promise<any> {
    try {
      const response = await this.baseService.http.get('orders/check-orders-open');
      return response.data;
    } catch (error) {
      console.error('Erro checkOrdersOpen:', error);
      throw error;
    }
  }

  async cancelPayment (params: CancelPaymentProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<any>(`cart/${params.cart_id}/cancel-payment`);
      return response.data;
    } catch (error) {
      console.error('Erro cancelPayment:', error);
      throw error;
    }
  }

  async detail(params: DetailProps, options = {}): Promise<OrderProps> {
    try {
      const response = await this.ApiBaseService.http.get<DetailProps>(`orders/${params.order_id}/view`);
      return response.data.order;
    } catch (error: any) {
      throw error;
    }
  }

}